import styled from 'styled-components';
import { tokens } from '../../public/tokens';
import { MOBILE_MEDIA_QUERY } from './breakpoints';

const { colors, typography, globals } = tokens;

/**
 * Base type styles shared across features. Spread these into a styled component
 * rather than repeating the token lookups, so a type change lands in one place.
 */
export const headingText = {
    fontFamily: globals['font-family'],
    fontWeight: typography.fontWeights.bold,
    fontSize: typography.fontSize['xl-18px'],
    color: colors.text.primary,
};

/**
 * A field/row label - the semibold 14px used by the checklist and card headings.
 */
export const labelText = {
    fontFamily: globals['font-family'],
    fontWeight: typography.fontWeights.semibold,
    fontSize: typography.fontSize['lg-14px'],
    color: colors.text.primary,
    lineHeight: '20px',
};

/**
 * Supporting copy under a heading or label.
 */
export const bodyText = {
    fontFamily: globals['font-family'],
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSize['lg-14px'],
    color: colors.text.secondary,
    lineHeight: '16px',
};

/**
 * Heading at the top of a dialog or page section.
 */
export const Title = styled.div({
    ...headingText,
    margin: 0,
    marginBottom: globals['spacing-sm'],
});

/**
 * Intro paragraph under a Title. Tightens its bottom margin on mobile.
 */
export const Description = styled.p({
    ...bodyText,
    color: colors.text.primary,
    margin: 0,
    marginBottom: globals['spacing-lg'],

    [MOBILE_MEDIA_QUERY]: {
        marginBottom: globals['spacing-md'],
    },
});
